import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import Dashboard from "../../components/Dashboard"
import { ENDPOINTS } from "../../constants"
import {
  keyItemDataHasData,
  arrayValuesHaveData,
  nineBoxGridHasData,
} from "../../utils/object-utils"
import actionTypePrefixes from "../../state/actions/actionTypePrefixes"
import {
  GoalStatusBreakdown,
  OverallBehaviourAverageDoughnut,
  GoalScoreDoughnut,
  ValueAlignment,
  PerformanceScoreDoughnut,
  BehavioursBreakdown,
  NineBoxGridLarge,
} from "../../components/widgets"

class PerformanceAndProgressionDashboard extends Component {
  static propTypes = {
    onReload: PropTypes.func.isRequired,
  }

  render() {
    const { t, onReload } = this.props // eslint-disable-line react/prop-types
    const { isLoading, errorMessageKey, widgets, loadingFailed } = this.props.dashboard // eslint-disable-line
    const title = t("Dashboards.Names.PerformanceAndProgression")

    return (
      <Dashboard
        errorMessageKey={errorMessageKey}
        isLoading={isLoading}
        loadingFailed={loadingFailed}
        onReload={onReload}
        title={title}
        widgetData={widgets}
      >
        {nineBoxGridHasData(widgets.nineBoxGridSummary.data) && (
          <NineBoxGridLarge
            summaryData={widgets.nineBoxGridSummary.data.reviews}
            drilldownData={widgets.nineBoxGridDrilldown.data}
            appliedFilters={widgets.goalStatusBreakdown.filters}
            exportEndpoint={ENDPOINTS.Export.NineBoxGridLarge}
            dashboard={actionTypePrefixes.PerformanceAndProgression}
            subtitleKey={widgets.nineBoxGridSummary.subtitle}
          />
        )}

        {arrayValuesHaveData(widgets.overallBehaviourAverage.data) && (
          <OverallBehaviourAverageDoughnut
            data={widgets.overallBehaviourAverage.data}
            appliedFilters={widgets.overallBehaviourAverage.filters}
            exportEndpoint={ENDPOINTS.Export.BehaviourAverage}
            subtitleKey={widgets.overallBehaviourAverage.subtitle}
            sampleSize={widgets.overallBehaviourAverage.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.behavioursBreakdown.data) && (
          <BehavioursBreakdown
            data={widgets.behavioursBreakdown.data}
            appliedFilters={widgets.behavioursBreakdown.filters}
            exportEndpoint={ENDPOINTS.Export.BehaviourBreakdown}
            subtitleKey={widgets.behavioursBreakdown.subtitle}
            sampleSize={widgets.behavioursBreakdown.sampleSize}
          />
        )}

        {arrayValuesHaveData(widgets.goalScore.data) && (
          <GoalScoreDoughnut
            data={widgets.goalScore.data}
            appliedFilters={widgets.goalScore.filters}
            exportEndpoint={ENDPOINTS.Export.GoalScore}
            subtitleKey={widgets.goalScore.subtitle}
            sampleSize={widgets.goalScore.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.goalStatusBreakdown.data) && (
          <GoalStatusBreakdown
            data={widgets.goalStatusBreakdown.data}
            appliedFilters={widgets.goalStatusBreakdown.filters}
            exportEndpoint={ENDPOINTS.Export.GoalStatusBreakdown}
          />
        )}

        {keyItemDataHasData(widgets.valueAlignment.data) && (
          <ValueAlignment
            data={widgets.valueAlignment.data}
            appliedFilters={widgets.valueAlignment.filters}
            exportEndpoint={ENDPOINTS.Export.ValueAlignment}
            subtitleKey={widgets.valueAlignment.subtitle}
            sampleSize={widgets.valueAlignment.sampleSize}
          />
        )}

        {arrayValuesHaveData(widgets.performanceScore.data) && (
          <PerformanceScoreDoughnut
            data={widgets.performanceScore.data}
            appliedFilters={widgets.performanceScore.filters}
            exportEndpoint={ENDPOINTS.Export.PerformanceScore}
            subtitleKey={widgets.performanceScore.subtitle}
          />
        )}
      </Dashboard>
    )
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.performanceAndProgression,
  }
}

export default compose(translate(), connect(mapStateToProps))(PerformanceAndProgressionDashboard)



// WEBPACK FOOTER //
// ./src/routes/dashboards/PerformanceAndProgressionDashboard.jsx